import { useState } from 'react';

function StepTwo({ onComplete, onAnswerUpdate, onNavigationStateChange }) {
  const [showWelcome, setShowWelcome] = useState(true);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({
    moodChanges: null,
    sleepPattern: null,
    energyLevel: null
  });

  const questions = [
    {
      id: "moodChanges",
      text: "Have you experienced significant changes in your mood over the past two weeks?",
      description: "Think about feelings of sadness, irritability, or emotional highs and lows."
    },
    {
      id: "sleepPattern",
      text: "Have your sleep patterns changed significantly?",
      description: "Consider difficulty falling asleep, staying asleep, or sleeping too much."
    },
    {
      id: "energyLevel",
      text: "Have you noticed changes in your energy levels or motivation?",
      description: "Reflect on feelings of fatigue, lack of interest in activities, or unusual restlessness."
    },
    {
      id: "anxietyLevels",
      text: "Have you been feeling more anxious or worried than usual?",
      description:
        "This includes persistent worry, feeling on edge, or difficulty relaxing."
    },
    {
      id: "concentrationIssues",
      text: "Have you had difficulty concentrating or making decisions recently?",
      description:
        "Think about forgetfulness, trouble focusing, or feeling mentally foggy."
    }
  ];

  const updateNavigationState = (canContinue, showWelcomeScreen) => {
    if (onNavigationStateChange) {
      onNavigationStateChange({
        canContinue,
        showWelcome: showWelcomeScreen,
        currentQuestion,
        totalQuestions: questions.length
      });
    }
  };

  const handleAnswerChange = (value) => {
    const questionId = questions[currentQuestion].id;
    const updatedAnswers = { ...answers, [questionId]: value };
    setAnswers(updatedAnswers);
    if (onAnswerUpdate) onAnswerUpdate(updatedAnswers);
    updateNavigationState(true, showWelcome);
  };

  const getCurrentAnswer = () => answers[questions[currentQuestion].id];

  const handleStart = () => {
    setShowWelcome(false);
    updateNavigationState(getCurrentAnswer() !== null, false);
  };

  const handleContinue = () => {
    if (currentQuestion < questions.length - 1) {
      const nextQuestion = currentQuestion + 1;
      setCurrentQuestion(nextQuestion);
      const nextAnswered = answers[questions[nextQuestion].id] !== null;
      updateNavigationState(nextAnswered, false);
    } else {
      if (onComplete) onComplete(answers);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      const prevQuestion = currentQuestion - 1;
      setCurrentQuestion(prevQuestion);
      const prevAnswered = answers[questions[prevQuestion].id] !== null;
      updateNavigationState(prevAnswered, false);
    } else {
      setShowWelcome(true);
      updateNavigationState(true, true);
    }
  };

  if (typeof window !== 'undefined') {
    window.step2Methods = {
      handleStart,
      handleContinue,
      handlePrevious
    };
  }

  if (showWelcome) {
    return (
      <div className="max-w-2xl mx-auto text-center">
        <h3 className="text-2xl md:text-3xl font-bold mb-6" style={{ color: '#132573' }}>
          Recent Emotional Patterns
        </h3>
        <p className="text-base text-gray-700 leading-relaxed">
          The next few questions will help us understand your recent emotional and behavioral patterns. 
          Your honest responses will help us provide personalized support and guidance.
        </p>
      </div>
    );
  }

  const currentQ = questions[currentQuestion];

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6 text-sm font-medium" style={{ color: '#f88226' }}>
        Question {currentQuestion + 1} of {questions.length}
      </div>

      <h4 className="text-xl font-semibold mb-4" style={{ color: '#132573' }}>
        {currentQ.text}
      </h4>

      <p className="text-gray-600 mb-8 text-base">
        {currentQ.description}
      </p>

      <div className="space-y-3">
        {['yes', 'no'].map((option) => (
          <label
            key={option}
            className={`flex items-center p-4 rounded-lg border-2 cursor-pointer transition-all ${
              getCurrentAnswer() === option
                ? 'bg-blue-50 border-blue-600'
                : 'bg-white border-gray-300 hover:border-gray-400'
            }`}
          >
            <input
              type="radio"
              name={currentQ.id}
              value={option}
              checked={getCurrentAnswer() === option}
              onChange={(e) => handleAnswerChange(e.target.value)}
              className="w-5 h-5 text-blue-600 focus:ring-blue-500"
            />
            <span className="ml-3 text-base font-medium text-gray-700 capitalize">
              {option}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}

export default StepTwo;